import * as React from 'react';
import styles from './index.less';
import TipPopover from './TipPopover';
import { type IAttrsAndConfigsItem } from '../';
import { FUtil } from '@freelog/tools-lib';
import EditValuePopover from './EditValuePopover';
import FComponentsLib from '@freelog/components-lib';
import FIcons from '@/components/FIcons';

interface AttrsAndConfigsItemProps {
  data: IAttrsAndConfigsItem;
  onChange?(
    dataOld: IAttrsAndConfigsItem,
    dataNew: IAttrsAndConfigsItem,
    changedFields: Array<Omit<keyof IAttrsAndConfigsItem, 'configs'>>,
  ): void;
  onDelete?(): void;
  disabledKeys: string[];
  disabledNames: string[];
  itemWidth?: string | number;
}

function AttrsAndConfigsItem({
  data,
  onChange,
  onDelete,
  disabledKeys,
  disabledNames,
  itemWidth,
}: AttrsAndConfigsItemProps) {
  const ref_editValuePopover = React.useRef<HTMLDivElement>(null);

  const [$showEdit, set$showEdit, get$showEdit] = FUtil.Hook.useGetState<boolean>(false);

  const valueEditable = data.configs.value_Editable;
  // Figma「属性填写控件」初始态右侧图标：日期 / 时间·时长 / 下拉
  const valueTypeIcon = (() => {
    if (!valueEditable) {
      return null;
    }
    if (valueEditable.date) {
      return <FIcons.FDate className={styles.valueTypeIcon} />;
    }
    if (valueEditable.dataTime) {
      return <FIcons.FTime className={styles.valueTypeIcon} />;
    }
    if (valueEditable.configEnum) {
      return <FIcons.FExpand className={styles.valueTypeIconEnum} />;
    }
    return null;
  })();

  return (
    <div className={styles.item} ref={ref_editValuePopover} style={{ flexBasis: itemWidth }}>
      <div className={styles.title}>
        <TipPopover
          info={{
            key: data.key,
            name: data.name,
            description: data.description,
          }}
          refContainer={ref_editValuePopover}
          configs={{
            key_Editable: data.configs.key_Editable,
            name_Editable: data.configs.name_Editable,
            description_Editable: data.configs.description_Editable,
          }}
          disabledKeys={disabledKeys}
          disabledNames={disabledNames}
          onChange={(res) => {
            onChange?.(
              data,
              {
                ...data,
                key: res.key,
                name: res.name,
                description: res.description,
              },
              ['key', 'name', 'description'],
            );
          }}
        >
          <span>{data.name}</span>
        </TipPopover>
      </div>
      {valueEditable && (
        <div
          className={styles.value_Editable}
          style={{ color: data.value ? '#222' : '#999' }}
          onClick={() => {
            setTimeout(() => {
              set$showEdit(true);
            }, 1);
          }}
        >
          <span className={styles.valueText}>{data.value || ''}</span>
          {valueTypeIcon}
        </div>
      )}

      {!data.configs.value_Editable && <div className={styles.value}>{data.value || ''} </div>}

      {data.configs.item_Deletable && (
        <FComponentsLib.FTextBtn
          type={'danger'}
          onClick={() => {
            onDelete?.();
          }}
          style={{ flexShrink: 0 }}
        >
          <FIcons.FCircleDelete style={{ fontSize: 14 }} />
        </FComponentsLib.FTextBtn>
      )}

      {$showEdit && valueEditable && (
        <EditValuePopover
          onCancel={() => {
            set$showEdit(false);
          }}
          name={data.name}
          value={data.value}
          onOk={(value) => {
            set$showEdit(false);
            onChange?.(data, { ...data, value }, ['value']);
          }}
          configs={valueEditable}
        />
      )}
    </div>
  );
}

export default AttrsAndConfigsItem;
